import { render, staticRenderFns } from "./status-text.vue?vue&type=template&id=11758f59&scoped=true&"
import script from "./status-text.vue?vue&type=script&lang=js&"
export * from "./status-text.vue?vue&type=script&lang=js&"
import style0 from "./status-text.vue?vue&type=style&index=0&id=11758f59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11758f59",
  null
  
)

export default component.exports